jQuery(document).ready(function($){

	var $body = $('body'),
		$wrapper = $('.wrapper'),
		$footer = $('footer');

  	// Footer : Accordian
  	var $footerColumn = $('.footer-column');
  	var $footerHeader = $('.footer-column-header');	
  
  	$footerHeader.on('click', function(e) {
      	if ($(this).parent().hasClass('is-open') ) {
          	$footerColumn.removeClass('is-open');
      	} else {
            $footerColumn.removeClass('is-open');
  			$(this).parent().addClass('is-open');
      	}
    });
  
  	function menuSecondaryClose() {
        $menuSecondaryHasDropdown.removeClass('active');
        $menuSecondaryDropdown.removeClass('is-visible');
    }
  
	// Modal Defaults
 	if ($('[data-modal]').length) {	
      new VenoBox({
          selector: '[data-modal]',
          spinner : 'flow',
          spinColor : '#000',
      });
    }
  
	// Toggle Class
	$body.on('click','[data-toggle]', function(e){
		e.preventDefault();
		$body.toggleClass($(this).data('toggle'));
	});	 
		
});